import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycConsentSubmittedProps = EventProps

/**
 * @event onboarding_kyc_consent_submitted
 * @description Emitted when the user completes the FrankieOne KYC consent screen and advances to personal details.
 */
export const OnboardingKycConsentSubmittedAnalytics = createAnalyticsStatic<OnboardingKycConsentSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_CONSENT_SUBMITTED,
)

export default OnboardingKycConsentSubmittedAnalytics
